export default "__VITE_ASSET__DO3bQh$G__"